// import React from 'react';
// import ReactMarkdown from 'react-markdown';
// import rehypeRaw from 'rehype-raw';
// import { slugifyHeading } from '../ActionToolbar/TableOfContents';

// function getTextFromChildren(children) {
//   return React.Children.toArray(children)
//     .map((child) => {
//       if (typeof child === 'string') return child;
//       if (typeof child === 'number') return String(child);
//       if (React.isValidElement(child)) {
//         return getTextFromChildren(child.props.children);
//       }
//       return '';
//     })
//     .join('');
// }
// export default function MessageMarkdown({ content, isDarkMode }) {
//   let h2Index = 0;

//   return (
//     <ReactMarkdown
//       rehypePlugins={[rehypeRaw]}
//       components={{
//         h1: ({ children, ...props }) => (
//           <h1
//             className={`text-xl font-bold mb-3 mt-4 border-b pb-1 ${
//               isDarkMode
//                 ? 'text-gray-100 border-gray-700'
//                 : 'text-gray-900 border-gray-300'
//             }`}
//             {...props}
//           >
//             {children}
//           </h1>
//         ),

//         h2: ({ children, ...props }) => {
//           const text = getTextFromChildren(children)
//             .replace(/[#*_`~]/g, '')
//             .replace(/[^\w\s-]/g, '')
//             .trim();

//           const id = slugifyHeading(text, h2Index++);

//           return (
//             <h2
//               {...props}
//               id={id}
//               className={`scroll-mt-24 text-lg font-semibold mb-2 mt-4 ${
//                 isDarkMode ? 'text-gray-200' : 'text-brand'
//               }`}
//             >
//               {children}
//             </h2>
//           );
//         },

//         h3: ({ children, ...props }) => (
//           <h3
//             className={`text-base font-semibold mb-2 mt-3 ${
//               isDarkMode ? 'text-gray-300' : 'text-brand'
//             }`}
//             {...props}
//           >
//             {children}
//           </h3>
//         ),

//         p: ({ children, ...props }) => (
//           <p
//             className={`mb-2 text-sm leading-6 ${
//               isDarkMode ? 'text-gray-200' : 'text-gray-800'
//             }`}
//             {...props}
//           >
//             {children}
//           </p>
//         ),

//         ol: ({ children, ...props }) => (
//           <ol
//             className={`mb-2 list-decimal pl-6 ${
//               isDarkMode ? 'text-gray-200' : 'text-gray-800'
//             }`}
//             {...props}
//           >
//             {children}
//           </ol>
//         ),

//         ul: ({ children, ...props }) => (
//           <ul
//             className={`mb-2 list-disc pl-6 ${
//               isDarkMode ? 'text-gray-200' : 'text-gray-800'
//             }`}
//             {...props}
//           >
//             {children}
//           </ul>
//         ),

//         li: ({ children, ...props }) => (
//           <li
//             className={`mb-1 text-sm leading-6 ${
//               isDarkMode ? 'text-gray-200' : 'text-gray-800'
//             }`}
//             {...props}
//           >
//             {children}
//           </li>
//         ),

//         strong: ({ children, ...props }) => (
//           <strong
//             className={`font-semibold ${
//               isDarkMode ? 'text-gray-100' : 'text-brand'
//             }`}
//             {...props}
//           >
//             {children}
//           </strong>
//         ),

//         a: ({ children, ...props }) => (
//           <a
//             className={`underline ${
//               isDarkMode ? 'text-indigo-400' : 'text-brand'
//             }`}
//             target="_blank"
//             rel="noopener noreferrer"
//             {...props}
//           >
//             {children || 'Link'}
//           </a>
//         ),

//         blockquote: ({ children, ...props }) => (
//           <blockquote
//             className={`border-l-4 pl-4 italic my-3 ${
//               isDarkMode
//                 ? 'text-gray-400 border-gray-600'
//                 : 'text-gray-600 border-gray-400'
//             }`}
//             {...props}
//           >
//             {children}
//           </blockquote>
//         ),

//         code: ({ inline, children, ...props }) =>
//           inline ? (
//             <code
//               className={`px-1.5 py-0.5 rounded text-sm ${
//                 isDarkMode
//                   ? 'bg-gray-800 text-gray-200'
//                   : 'bg-gray-100 text-gray-800'
//               }`}
//               {...props}
//             >
//               {children}
//             </code>
//           ) : (
//             <code
//               className={`block p-4 rounded-lg overflow-x-auto text-sm ${
//                 isDarkMode
//                   ? 'bg-gray-800 text-gray-200'
//                   : 'bg-gray-100 text-gray-800'
//               }`}
//               {...props}
//             >
//               {children}
//             </code>
//           ),
//       }}
//     >
//       {content}
//     </ReactMarkdown>
//   );
// }
import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { slugifyHeading } from '../ActionToolbar/TableOfContents';

function getTextFromChildren(children) {
  return React.Children.toArray(children)
    .map((child) => {
      if (typeof child === 'string') return child;
      if (typeof child === 'number') return String(child);
      if (React.isValidElement(child)) {
        return getTextFromChildren(child.props.children);
      }
      return '';
    })
    .join('');
}

export default function MessageMarkdown({ content = '', isDarkMode }) {
  let h2Index = 0;

  return (
    <ReactMarkdown
      rehypePlugins={[rehypeRaw]}
      components={{
        h1: ({ children, ...props }) => (
          <h1
            className={`mb-3 mt-4 border-b pb-2 text-xl font-bold ${
              isDarkMode
                ? 'border-gray-700 text-gray-100'
                : 'border-gray-300 text-gray-900'
            }`}
            {...props}
          >
            {children}
          </h1>
        ),

        h2: ({ children, ...props }) => {
          const text = getTextFromChildren(children)
            .replace(/[#*_`~]/g, '')
            .replace(/[^\w\s-]/g, '')
            .trim();

          const id = slugifyHeading(text, h2Index++);

          return (
            <h2
              {...props}
              id={id}
              className={`mb-2 mt-5 scroll-mt-24 border-b pb-1 text-lg font-semibold ${
                isDarkMode
                  ? 'border-gray-700 text-gray-200'
                  : 'border-gray-200 text-gray-900'
              }`}
            >
              {children}
            </h2>
          );
        },

        h3: ({ children, ...props }) => (
          <h3
            className={`mb-2 mt-4 text-base font-semibold ${
              isDarkMode ? 'text-gray-300' : 'text-gray-900'
            }`}
            {...props}
          >
            {children}
          </h3>
        ),

        p: ({ children, ...props }) => (
          <p
            className={`mb-3 text-sm leading-7 ${
              isDarkMode ? 'text-gray-200' : 'text-gray-800'
            }`}
            {...props}
          >
            {children}
          </p>
        ),

        ol: ({ children, ...props }) => (
          <ol
            className={`mb-3 list-decimal space-y-1 pl-6 text-sm leading-7 ${
              isDarkMode ? 'text-gray-200' : 'text-gray-800'
            }`}
            {...props}
          >
            {children}
          </ol>
        ),

        ul: ({ children, ...props }) => (
          <ul
            className={`mb-3 list-disc space-y-1 pl-6 text-sm leading-7 ${
              isDarkMode ? 'text-gray-200' : 'text-gray-800'
            }`}
            {...props}
          >
            {children}
          </ul>
        ),

        li: ({ children, ...props }) => (
          <li
            className={`pl-1 ${isDarkMode ? 'text-gray-200' : 'text-gray-800'}`}
            {...props}
          >
            {children}
          </li>
        ),

        strong: ({ children, ...props }) => (
          <strong
            className={`font-semibold ${
              isDarkMode ? 'text-gray-100' : 'text-gray-950'
            }`}
            {...props}
          >
            {children}
          </strong>
        ),

        em: ({ children, ...props }) => (
          <em
            className={`italic ${
              isDarkMode ? 'text-gray-300' : 'text-gray-700'
            }`}
            {...props}
          >
            {children}
          </em>
        ),

        a: ({ children, href, ...props }) => (
          <a
            href={href}
            className={`underline underline-offset-2 ${
              isDarkMode
                ? 'text-indigo-400 hover:text-indigo-300'
                : 'text-indigo-700 hover:text-indigo-900'
            }`}
            target="_blank"
            rel="noopener noreferrer"
            {...props}
          >
            {children || href || 'Link'}
          </a>
        ),

        blockquote: ({ children, ...props }) => (
          <blockquote
            className={`my-4 border-l-4 pl-4 text-sm italic leading-7 ${
              isDarkMode
                ? 'border-gray-600 text-gray-400'
                : 'border-gray-400 text-gray-600'
            }`}
            {...props}
          >
            {children}
          </blockquote>
        ),

        code: ({ inline, children, ...props }) =>
          inline ? (
            <code
              className={`rounded px-1.5 py-0.5 text-[13px] ${
                isDarkMode
                  ? 'bg-gray-800 text-gray-200'
                  : 'bg-gray-100 text-gray-800'
              }`}
              {...props}
            >
              {children}
            </code>
          ) : (
            <code
              className={`block overflow-x-auto rounded-lg p-4 text-sm leading-6 ${
                isDarkMode
                  ? 'bg-gray-900 text-gray-200'
                  : 'bg-gray-100 text-gray-800'
              }`}
              {...props}
            >
              {children}
            </code>
          ),

        pre: ({ children, ...props }) => (
          <pre className="my-4 overflow-x-auto" {...props}>
            {children}
          </pre>
        ),

        hr: ({ ...props }) => (
          <hr
            className={`my-5 border-t ${
              isDarkMode ? 'border-gray-700' : 'border-gray-200'
            }`}
            {...props}
          />
        ),

        table: ({ children, ...props }) => (
          <div className="my-4 overflow-x-auto">
            <table
              className={`w-full border-collapse text-sm ${
                isDarkMode ? 'text-gray-200' : 'text-gray-800'
              }`}
              {...props}
            >
              {children}
            </table>
          </div>
        ),

        thead: ({ children, ...props }) => (
          <thead
            className={isDarkMode ? 'bg-gray-800' : 'bg-gray-50'}
            {...props}
          >
            {children}
          </thead>
        ),

        th: ({ children, ...props }) => (
          <th
            className={`border px-3 py-2 text-left font-semibold ${
              isDarkMode ? 'border-gray-700' : 'border-gray-200'
            }`}
            {...props}
          >
            {children}
          </th>
        ),

        td: ({ children, ...props }) => (
          <td
            className={`border px-3 py-2 align-top ${
              isDarkMode ? 'border-gray-700' : 'border-gray-200'
            }`}
            {...props}
          >
            {children}
          </td>
        ),
      }}
    >
      {content}
    </ReactMarkdown>
  );
}
